import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Verwaiste Service Worker aus Vorgaenger-Versionen deregistrieren --
// zweite Verteidigungslinie neben dem Kill-Switch in public/service-worker.js
// (Vorfall 2026-07-14: Handy zeigte monatelang eine Precache-Version).
if ("serviceWorker" in navigator) {
    navigator.serviceWorker
        .getRegistrations()
        .then((regs) => regs.forEach((r) => r.unregister()))
        .catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
